import React from 'react';
import { inject, observer } from 'mobx-react';
import { Field, renderToggle } from "../../../../utils/formFieldHelper";
import Section from '../../../Section/Section';
import Form from '../../../Settings/Form/Form';
import { StoresEnum } from '../../../../stores';

import './UnitSettingsForm.scss';

const UnitSettingsForm = ({ channelStore: { channel, readOnly, updateChannel } }) => {
  const { unitGeneralSettings } = channel;

  const renderFields = () => (
    <>
      <div className="title-checkbox">
        <Field
          name="unitGeneralSettings.active"
          type="checkbox"
          component={renderToggle}
          readOnly={readOnly}
          label="UNIT GENERAL SETTINGS (these settings will be used as default on unit creation)"
          onChange={newValue => {
            updateChannel({
              ...channel,
              unitGeneralSettings: {
                ...unitGeneralSettings,
                active: newValue,
              },
            });
          }}
        />
      </div>
      <Field
        name="unitGeneralSettings.hideAuthor"
        type="checkbox"
        component={renderToggle}
        readOnly={readOnly || !unitGeneralSettings.active}
        label='Hide "Created by user"'
      />
      <Field
        name="unitGeneralSettings.hideChannel"
        type="checkbox"
        component={renderToggle}
        readOnly={readOnly || !unitGeneralSettings.active}
        label='Hide "Via channel" on cover slide'
      />
      <Field
        name="unitGeneralSettings.headerHideChannel"
        type="checkbox"
        component={renderToggle}
        readOnly={readOnly || !unitGeneralSettings.active}
        label="Hide channel name and logo on header"
      />
      <Field
        name="unitGeneralSettings.hideVotersCount"
        type="checkbox"
        component={renderToggle}
        readOnly={readOnly || !unitGeneralSettings.active}
        label="Hide number of voters"
      />
      <Field
        name="unitGeneralSettings.multipleVote"
        type="checkbox"
        component={renderToggle}
        readOnly={readOnly || !unitGeneralSettings.active}
        label="Allow multiple votes per person"
      />
      <Field
        name="unitGeneralSettings.shuffleSlides"
        type="checkbox"
        component={renderToggle}
        readOnly={readOnly || !unitGeneralSettings.active}
        label="Shuffle slides"
      />
      <Field
        name="unitGeneralSettings.hasLightAnimation"
        type="checkbox"
        component={renderToggle}
        readOnly={readOnly || !unitGeneralSettings.active}
        label="Hide results display on slides"
      />
      <Field
        name="unitGeneralSettings.displayShareButton"
        type="checkbox"
        component={renderToggle}
        readOnly={readOnly || !unitGeneralSettings.active}
        label="Display social share button"
      />
      <Field
        name="unitGeneralSettings.shouldTrack"
        type="checkbox"
        component={renderToggle}
        readOnly={readOnly || !unitGeneralSettings.active}
        label="Enable cookie tracking"
      />
      <Field
        name="unitGeneralSettings.includeToPlaylist"
        type="checkbox"
        component={renderToggle}
        readOnly={readOnly || !unitGeneralSettings.active}
        label="Include in Playlist (recommended)"
      />
      <Field
        name="unitGeneralSettings.excludeFromFeed"
        type="checkbox"
        component={renderToggle}
        readOnly={readOnly || !unitGeneralSettings.active}
        label='Exclude unit from appearing in your "up next" content (feed)'
      />
    </>
  );

  return (
    <Section title="" className="unit-settings-section">
      <Form
        initialValues={channel}
        fields={renderFields()}
        onSubmit={updateChannel}
        hideCancelButton
        hideApproveButton={readOnly}
      />
    </Section>
  );
};

export default inject(StoresEnum.CHANNEL)(observer(UnitSettingsForm));
